import React from "react";
import { useSelector } from "react-redux";

import { Icon } from "rhombus-react";
import { formatBytes } from "utils/common";
import UploadProgress from "widgets/UploadProgress";

import "./VASTUploadList.css";

export default function VASTUploadList(props){
	let fileList = useSelector((state) => {
		return state.creatives.vastItems;
	});

	return (
		<div className="vast-upload-list">
			<table className="basic-table">
				<thead>
					<tr>
						<th className="name-col">File Name</th>
						<th className="size-col">Size</th>
						<th>Upload Progress</th>
					</tr>
				</thead>
				<tbody>
					{fileList.map((v) => {
						let icon = "assetVideo"
							, iconClass = "is-video"
							, uploadMessage = <UploadProgress value={v.progress} max={v.size} />;

						if(v.progress&&v.progress < v.size){
							icon ="in-queue";
							iconClass="is-uploading";
						}
						if(v.progress >= v.size){
							icon ="in-queue";
							iconClass="is-uploading";
							uploadMessage = "Upload Complete";
						}
						if(v.success){
							icon = "success";
							iconClass = "is-complete";
							uploadMessage = "Upload Complete";
						}
						if(v.error){
							icon = "clearCircle";
							iconClass = "is-error";
							uploadMessage = "Upload Skipped";
						}

						return (
							<tr key={v.name} className="upload-row">
								<td className="name-col">
									<div className="upload-name" title={v.name}>
										<Icon name={icon} className={`progress-icon ${iconClass}`} />
										<span className="upload-file-name name-overflow">{v.name}</span>
									</div>
								</td>
								<td className="size-col">{formatBytes(v.size)}</td>
								<td className="progress-col">{uploadMessage}</td>
							</tr>
						);
					})}
				</tbody>
			</table>
		</div>
	);
}

VASTUploadList.displayName = "VASTUploadList";

export const PRIVATE ={
	 UploadProgress
	, VASTUploadList,
};
